import { render } from "./TheHeader.vue?vue&type=template&id=0fe7641b&ts=true"
import script from "./TheHeader.vue?vue&type=script&lang=ts"
export * from "./TheHeader.vue?vue&type=script&lang=ts"

import "./TheHeader.vue?vue&type=style&index=0&id=0fe7641b&lang=css"

import exportComponent from "F:\\hotaru_theme_for_RustVersion\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__